import { render } from "./Trip.vue?vue&type=template&id=6e67451c&scoped=true"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"

import "./Trip.vue?vue&type=style&index=0&id=6e67451c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e67451c"]])

export default __exports__